'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'bring-forward';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f856';
var svgPathData = ['M32 64L32 169.4 182.6 320 288 320c2.9 0 5.6-.4 8.3-1.1L33.1 55.7C32.4 58.4 32 61.1 32 64zm0 150.6L32 288c0 17.7 14.3 32 32 32L137.4 320 32 214.6zM55.7 33.1L318.9 296.3c.7-2.6 1.1-5.4 1.1-8.3L320 182.6 169.4 32 64 32c-2.9 0-5.6 .4-8.3 1.1zM214.6 32L320 137.4 320 64c0-17.7-14.3-32-32-32l-73.4 0z', 'M224 480l224 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-48 0 0-32 48 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64l0-48 32 0 0 48c0 17.7 14.3 32 32 32zM182.6 320L288 320c2.9 0 5.6-.4 8.3-1.1L33.1 55.7C32.4 58.4 32 61.1 32 64L32 169.4 182.6 320zM176 352L64 352c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L288 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-112 0zm-38.6-32L32 214.6 32 288c0 17.7 14.3 32 32 32l73.4 0zM320 137.4L320 64c0-17.7-14.3-32-32-32L214.6 32 320 137.4zM169.4 32L64 32c-2.9 0-5.6 .4-8.3 1.1L318.9 296.3c.7-2.6 1.1-5.4 1.1-8.3L320 182.6 169.4 32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBringForward = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;